import React, { useEffect, useState } from "react";
import {
  Edit,
  SimpleForm,
  TextInput,
  maxLength,
  required,
  FormDataConsumer,
  useRecordContext,
  useInput,
  regex,
  ImageInput,
  ImageField,
} from "react-admin";

import { CachedCategoriesInput } from "../common/CachedCategoriesInput/CachedCategoriesInput";

const ConditionalParentCategoryInput = ({
  formData,
  record: recordFromProps,
  ...rest
}) => {
  const record = useRecordContext();
  // eslint-disable-next-line no-unused-vars
  const { field } = useInput({
    source: "parentIdField",
    defaultValue: record?.parent || undefined,
  }); // DO NOT REMOVE THIS
  return (
    <CachedCategoriesInput
      source="parentIdField"
      label="Categoría Padre"
      filter={{ parent: null }}
      allowEmpty={true}
      helperText={
        "Seleccione una categoría padre (Si el campo está vacío, será seteada como una categoria Padre)."
      }
      perPage={200}
      sort={{ field: "name", order: "ASC" }}
      {...rest}
    />
  );
};

const CategoryTitle = ({ record }) => {
  return <span>Categoría {record ? `"${record.name}"` : ""}</span>;
};

export const CategoryEdit = (props) => {
  const record = useRecordContext(props);
  const [initialValues, setInitialValues] = useState({});

  useEffect(() => {
    if (record) {
      setInitialValues({
        ...record,
        parentIdField: record.parent,
      });
    }
  }, [record]);

  return (
    <Edit
      title={<CategoryTitle />}
      {...props}
      transform={(data) => {
        const { parentIdField, isRootCategory, ...restData } = data;
        return {
          ...restData,
          parent: isRootCategory ? null : parentIdField,
          featured: data.featured === null ? false : data.featured,
          products: data.products
            ? data.products.map((product) => product.id)
            : [],
          // childs: data.childs ? data.childs.map((child) => child.id) : [],
        };
      }}
    >
      <SimpleForm redirect="list" initialValues={initialValues}>
        <TextInput source="id" disabled style={{ width: "50px" }} />
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            gap: "10px",
            width: "100%",
          }}
        >
          <TextInput
            source="name"
            label="Nombre"
            validate={[required(), maxLength(100)]}
            style={{ width: "50%" }}
          />
          <TextInput
            source="slug"
            label="Slug"
            validate={[
              required(),
              maxLength(100),
              regex(
                /^[a-z0-9-]+$/,
                "Solo se permiten letras minúsculas, números y guiones. Sin espacios."
              ),
            ]}
            style={{ width: "50%" }}
          />
        </div>

        <FormDataConsumer>
          {({ formData, ...rest }) => (
            <ConditionalParentCategoryInput
              formData={formData}
              record={record}
              allowEmpty={true}
              {...rest}
            />
          )}
        </FormDataConsumer>
        <ImageInput
          source="image"
          label="Imagen"
          accept={{ "image/*": [".png", ".jpg", ".jpeg", ".gif"] }}
          placeholder="Haz clic aquí o arrastra y suelta la imagen"
          options={{
            preventDropOnDocument: true,
          }}
          format={(value) => {
            if (typeof value === "string" && value !== "") {
              return { src: value };
            }
            return value;
          }}
        >
          <ImageField source="src" title="title" />
        </ImageInput>
      </SimpleForm>
    </Edit>
  );
};
